import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import Index from '@/components/Index'
import TopAnimation from '@/components/TopAnimation'
import SelectTemplate from '@/components/SelectTemplate'
import Kiyaku from '@/components/auth/Kiyaku'
import View from '@/components/View'
import TopView from '@/components/TopView'
import QList from '@/components/QList'
import Edit from '@/components/Edit'
import Edit2 from '@/components/Edit2'
import TipAdd from '@/components/TipAdd'
import Chronology from '@/components/Chronology'
import Login from '@/components/auth/Login'
import Profile from '@/components/auth/Profile'
import EditProfile from '@/components/auth/EditProfile'
import TwitterView from '@/components/TwitterView'

Vue.use(Router)

let router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: TopView
    },
    {
      path: '/lp',
      name: 'Lp',
      component: Index
    },
    {
      path: '/test',
      name: 'TopAnimation',
      component: TopAnimation
    },
    {
      path: '/top',
      name: 'TopView',
      component: TopView
    },
    {
      path: '/v',
      name: 'View',
      component: View
    },
    {
      path: '/q',
      name: 'QList',
      component: QList
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/kiyaku',
      name: 'Kiyaku',
      component: Kiyaku
    },
    {
      path: '/selectTemplate',
      name: 'SelectTemplate',
      component: SelectTemplate,
      meta: {requiresAuth: true}
    },
    {
      path: '/edit_simple/:obj',
      name: 'EditSimple',
      component: Edit,
      meta: {requiresAuth: true}
    },
    {
      path: '/edit/:obj',
      name: 'Edit',
      component: Edit2,
      meta: {requiresAuth: true}
    },
    {
      path: '/tipAdd/:obj',
      name: 'TipAdd',
      component: TipAdd,
      meta: {requiresAuth: true}
    },
    {
      path: '/c/:id',
      name: 'Chronology',
      component: Chronology
    },
    {
      path: '/_c/:id',
      redirect: '/c/:id'
    },
    {
      path: '/c',
      name: 'Chronology_',
      component: Chronology
    },
    {
      path: '/csns/:id',
      name: 'Chronology_SNS',
      component: Chronology
    },
    {
      path: '/profile/:id',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/editProfile/:obj',
      name: 'EditProfile',
      component: EditProfile,
      meta: {requiresAuth: true}
    },
    {
      path: '/jbatboajsa24ty6qvaraTwitterView',
      name: 'TwitterView',
      component: TwitterView,
      meta: {requiresAuth: true}
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          name: 'Login',
          query: { redirect: to.fullPath }
        })
      }
    })
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js